var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipsisOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_678_40618",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 21,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.357056,
    y: -0.0102539,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_678_40618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.357 16.6566C9.8987 16.6566 9.50648 16.4935 9.18037 16.1674C8.8537 15.8407 8.69037 15.4482 8.69037 14.9899C8.69037 14.5316 8.8537 14.1391 9.18037 13.8124C9.50648 13.4863 9.8987 13.3232 10.357 13.3232C10.8154 13.3232 11.2079 13.4863 11.5345 13.8124C11.8606 14.1391 12.0237 14.5316 12.0237 14.9899C12.0237 15.4482 11.8606 15.8407 11.5345 16.1674C11.2079 16.4935 10.8154 16.6566 10.357 16.6566ZM10.357 11.6566C9.8987 11.6566 9.50648 11.4932 9.18037 11.1666C8.8537 10.8405 8.69037 10.4482 8.69037 9.98991C8.69037 9.53158 8.8537 9.13908 9.18037 8.81241C9.50648 8.4863 9.8987 8.32324 10.357 8.32324C10.8154 8.32324 11.2079 8.4863 11.5345 8.81241C11.8606 9.13908 12.0237 9.53158 12.0237 9.98991C12.0237 10.4482 11.8606 10.8405 11.5345 11.1666C11.2079 11.4932 10.8154 11.6566 10.357 11.6566ZM10.357 6.65658C9.8987 6.65658 9.50648 6.49324 9.18037 6.16658C8.8537 5.84046 8.69037 5.44824 8.69037 4.98991C8.69037 4.53158 8.8537 4.13935 9.18037 3.81324C9.50648 3.48658 9.8987 3.32324 10.357 3.32324C10.8154 3.32324 11.2079 3.48658 11.5345 3.81324C11.8606 4.13935 12.0237 4.53158 12.0237 4.98991C12.0237 5.44824 11.8606 5.84046 11.5345 6.16658C11.2079 6.49324 10.8154 6.65658 10.357 6.65658Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsisOptions);
export default __webpack_public_path__ + "static/media/ellipsis-options.77a9f6adc71d9b2a26d790ce18e1398e.svg";
export { ForwardRef as ReactComponent };